var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7012 9C29.7012 9 29.4082 6.93164 28.5059 6.02344C27.3633 4.82813 26.0859 4.82227 25.5 4.75195C21.3047 4.44727 15.0059 4.44727 15.0059 4.44727H14.9941C14.9941 4.44727 8.69531 4.44727 4.5 4.75195C3.91406 4.82227 2.63672 4.82813 1.49414 6.02344C0.591797 6.93164 0.304688 9 0.304688 9C0.304688 9 0 11.4316 0 13.8574V16.1309C0 18.5566 0.298828 20.9883 0.298828 20.9883C0.298828 20.9883 0.591797 23.0566 1.48828 23.9648C2.63086 25.1602 4.13086 25.1191 4.79883 25.248C7.20117 25.4766 15 25.5469 15 25.5469C15 25.5469 21.3047 25.5352 25.5 25.2363C26.0859 25.166 27.3633 25.1602 28.5059 23.9648C29.4082 23.0566 29.7012 20.9883 29.7012 20.9883C29.7012 20.9883 30 18.5625 30 16.1309V13.8574C30 11.4316 29.7012 9 29.7012 9ZM11.9004 18.8906V10.459L20.0039 14.6895L11.9004 18.8906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcons);
export default __webpack_public_path__ + "static/media/Social Icons.d48aa42ca450609df0f79873f1c29a26.svg";
export { ForwardRef as ReactComponent };